import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '同步',
    view: '查看',
    page: true,
    selection: false,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '450px',
    emptyText: '暂无数据',
    menu: false,

    // 人员/车牌、图片、通行时间、失效时间、同步状态、同步失败次数、同步失败原因、同步时间、操作
    column: [
      {
        label: '同步类型',
        prop: 'syncType',
        type: 'select',
        search: true,
        searchSlot: true,
        hide: false,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true,

        span: 24,
        viewFormatter: (row, value) => {
          if (Number(value) === 1) {
            return '人脸同步'
          } else if (Number(value) === 2) {
            return '车辆同步'
          }
          return '';
        },
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return '人脸同步'
          } else if (Number(value) === 2) {
            return '车辆同步'
          }
          return '';
        },
        dicData: [{
          label: '人脸同步',
          value: '1'
        },
        {
          label: '车辆同步',
          value: '2'
        }
        ],
      },
      {
        label: '闸机设备',
        prop: 'thirdDeviceName',
        type: 'select',
        search: true,
        searchSlot: true,
        hide: false,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true,

        span: 24,
        align: 'center',
      },
      {
        label: '人员姓名',
        prop: 'name',
        hide: false,
        search: true,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true,
        overHidden: true,
        align: 'center',
        span: 24,
      },
      {
        label: '车牌号码',
        prop: 'plateCode',
        search: true,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true,
        overHidden: true,
        align: 'center',
        span: 24,
      },
      {
        label: '图片',
        prop: 'fileCode',
        hide: false,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        viewslot: true,
        span: 24,
        align: 'center',
      },
      {
        label: '通行时间',
        prop: 'effectiveTime',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true,
        align: 'right',
        type: 'datetime',
        span: 24,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '失效时间',
        prop: 'expirationTime',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true,
        align: 'right',
        type: 'datetime',
        span: 24,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '同步状态',
        prop: 'status',
        type: 'select',
        search: false,
        hide: false,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true,
        span: 24,
        align: 'center',
        viewFormatter: (row, value) => {
          if (Number(value) === 0) {
            return '成功'
          } else if (Number(value) === 1) {
            return '失败'
          } else if (Number(value) === 2) {
            return '待同步'
          }
          return '';
        },
        formatter: (row, value) => {
          if (Number(value) === 0) {
            return '成功'
          } else if (Number(value) === 1) {
            return '失败'
          } else if (Number(value) === 2) {
            return '待同步'
          }
          return '';
        },
        dicData: [{
          label: '成功',
          value: 0
        },
        {
          label: '失败',
          value: 1
        },
        {
          label: '待同步',
          value: 2
        }
        ],
      },
      {
        label: '同步失败次数',
        prop: 'failTimes',
        search: false,
        hide: false,
        addDisplay: false,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true,
        span: 24,
        align: 'center'
      },
      {
        label: '同步失败原因',
        prop: 'failReason',
        searchSlot: true,
        hide: true,
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12,
      },
      {
        label: '同步时间',
        prop: 'syncTime',
        type: 'datetimerange',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: false,
        hide: true,
        valueFormat: 'timestamp',
        span: 12,
        align: 'center',
      },
    ]
  }
}